import { createCssIndex, rehydrateEventCss } from '../../api/replay/cssDedupe';

const EXTENSION_MEDIA_URL = /chrome-extension:\/\/[^/"\\]+\/static\/media\//g;

/** Own one recording's decoded data; never keep a cache of previous recordings. */
export async function loadReplay(apiClient, replayId, signal, onMetadata) {
  const events = [];
  const cssIndex = createCssIndex();
  const check = () => { if (signal.aborted) throw new DOMException('Aborted', 'AbortError'); };
  const clear = () => {
    events.length = 0;
    cssIndex.byId.clear();
    cssIndex.byText.clear();
  };
  signal.addEventListener('abort', clear);
  try {
    const data = await apiClient.getReplay(replayId);
    check();
    onMetadata?.(data.replay);
    if (!data.chunks?.length) throw new Error('This recording has no stored events.');
    // CSS definitions can be referenced in later chunks, so decode in order.
    for (const chunk of data.chunks) {
      check();
      const response = await fetch(chunk.url, { signal });
      if (!response.ok) throw new Error(`chunk ${chunk.key} → HTTP ${response.status}`);
      let text;
      if (chunk.key.endsWith('.gz')) {
        if (typeof DecompressionStream === 'undefined') throw new Error('This browser cannot decompress the replay.');
        text = await new Response(response.body.pipeThrough(new DecompressionStream('gzip'))).text();
      } else {
        text = await response.text();
      }
      check();
      const chunkEvents = JSON.parse(text.replace(EXTENSION_MEDIA_URL, `${window.location.origin}/static/media/`));
      text = null;
      for (const event of chunkEvents) events.push(rehydrateEventCss(event, cssIndex));
    }
    check();
    if (events.length < 2) throw new Error('Not enough events to play this recording.');
    if (cssIndex.unresolved) console.log(`replay: ${cssIndex.unresolved} stylesheet references could not be resolved`);
    return { replay: { ...data.replay, replayId }, events };
  } catch (error) {
    clear();
    throw error;
  } finally {
    signal.removeEventListener('abort', clear);
    cssIndex.byId.clear();
    cssIndex.byText.clear();
  }
}
